import React from 'react';

import { WithColor } from '@styles/colors';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

import { STEP, type StepIndex } from '@components/tenantStatus/onboardingWizard/constants';
import type { WizardFormState } from '@components/tenantStatus/onboardingWizard/types';

import WelcomeStep from './steps/WelcomeStep';
import MachinesStep from './steps/MachinesStep';
import ErpStep from './steps/ErpStep';
import GoalsStep from './steps/GoalsStep';
import TeamStep from './steps/TeamStep';
import ThankYouStep from './steps/ThankYouStep';

export interface WizardStepRendererProps extends WithColor {
  step: StepIndex;
  form: WizardFormState;
  onGetStarted: () => void;
  onUpdateMachines: (next: WizardFormState['machines']) => void;
  onUpdateErp: (next: WizardFormState['erp']) => void;
  onUpdateGoals: (next: WizardFormState['goals']) => void;
  onUpdateTeam: (next: WizardFormState['team']) => void;
}

const ids = TEST_IDS.tenantStatus.onboardingWizard;

const WizardStepRenderer = ({
  C,
  step,
  form,
  onGetStarted,
  onUpdateMachines,
  onUpdateErp,
  onUpdateGoals,
  onUpdateTeam,
}: WizardStepRendererProps) => {
  switch (step) {
    case STEP.WELCOME:
      return <WelcomeStep C={C} onGetStarted={onGetStarted} testID={ids.welcomeGetStarted} />;
    case STEP.MACHINES:
      return <MachinesStep C={C} data={form.machines} onChange={onUpdateMachines} />;
    case STEP.ERP:
      return <ErpStep C={C} data={form.erp} onChange={onUpdateErp} />;
    case STEP.GOALS:
      return <GoalsStep C={C} data={form.goals} onChange={onUpdateGoals} />;
    case STEP.TEAM:
      return <TeamStep C={C} data={form.team} onChange={onUpdateTeam} />;
    case STEP.SUBMITTED:
      return <ThankYouStep C={C} testID={ids.thankYou} />;
  }
};

export default WizardStepRenderer;
